export const CONTACT_BLOCK_MESSAGE =
  "Concealed within his fortress, the lord of Mordor sees all. His gaze pierces cloud, shadow, earth, and flesh.\n\nThus, no trader may stray beyond Kraahl’s walls: no hidden roads, no secret payments, no dealings carried out in distant halls. All bargains must remain within the realm—even when contact clues are split across several messages.\n\nBefore you proceed on your journey, take a moment to consult our Terms of Service (ToS).";

export const CONTACT_BLOCK_GENERIC_ERROR =
  "We couldn't send that message. Please try again.";

export const ILLEGAL_CONTENT_MESSAGE =
  "Concealed within his fortress, the lord of Mordor sees all. His gaze pierces cloud, shadow, earth, and flesh.\n\nThus, no illegal goods, no deceit, and no acts of malice shall be tolerated within the borders of Kraahl.\n\nBefore you proceed on your journey, take a moment to consult our Terms of Service (ToS).";

export const CONTACT_BLOCK_REASON_SHORT = "Contact policy violation";

export const ILLEGAL_CONTENT_REASON_SHORT = "Illegal or regulated content";

export const VIOLATION_MESSAGES: Record<string, string> = {
  contact: CONTACT_BLOCK_MESSAGE,
  illegal: ILLEGAL_CONTENT_MESSAGE,
  harassment:
    "Concealed within his fortress, the lord of Mordor hears every whisper.\n\nBefore you proceed, take a moment to consult our Terms of Service (ToS).",
};

export const VIOLATION_REASONS_SHORT: Record<string, string> = {
  contact: CONTACT_BLOCK_REASON_SHORT,
  illegal: ILLEGAL_CONTENT_REASON_SHORT,
  harassment: "Harassment or violent content",
};

export const GENERAL_VIOLATION_MESSAGE = VIOLATION_MESSAGES.harassment;
export const GENERAL_VIOLATION_REASON_SHORT = VIOLATION_REASONS_SHORT.harassment;

